<!-- 求职意向 -->
<template>
  <div class="edit-boxs">
    <!--期望职位-->
    <div class="edit-item degree" @click="duty=true">
      <div>
        <p>期望职位</p>
        <input type="text" placeholder="请选择期望职位" class="printf-input" v-model="dutyName" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="duty" round position="bottom">
      <van-picker
        title="期望职位"
        show-toolbar
        :columns="dutyList"
        @confirm="selectDuty"
        @cancel="duty=false"
        @change="changeDuty"
        value-key="name"
      />
    </van-popup>
    <!-- <div class="edit-item">
      <p>期望职位</p>
      <input type="text" placeholder="如：销售经理" class="printf-input" />
    </div>-->
    <!-- 薪资要求 -->
    <div class="edit-item degree" @click="showPickers=true">
      <div>
        <p>薪资要求</p>
        <input type="text" placeholder="请选择" class="printf-input" v-model="price" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="showPickers" round position="bottom">
      <van-picker
        title="薪资选择"
        show-toolbar
        :columns="salary"
        @confirm="selectSalary"
        @cancel="showPickers=false"
        value-key="name"
      />
    </van-popup>
    <!-- 工作地点 -->
    <div class="edit-item degree" @click="address=true">
      <div>
        <p>工作地点</p>
        <input type="text" placeholder="请选择工作地点" class="printf-input" v-model="workArea" disabled />
      </div>
      <img src="@/assets/img/position/into.png" class="back" />
    </div>
    <van-popup v-model="address" round position="bottom">
      <van-picker
        title="工作地点"
        show-toolbar
        :columns="worhAddress"
        @confirm="selectAddress"
        @cancel="address=false"
        @change="Onchange"
        value-key="name"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  getPosition,
  positionDetails,
  getKindArray,
  getAreaKinds
} from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: {},
  props: ["resumeId"],
  data() {
    return {
      showPickers: false, //薪资弹窗
      price: "", //薪资
      priceId: "", //期望薪资id
      workArea: "", //工作地点
      workId: "", //工作地点id
      address: false,
      duty: false,
      dutyName: "", //期望职位
      id: "", //用来判断 避免一直请求数据 提高性能
      dutyId: "", //期望职位id
      dutyList: [
        { values: [], className: "column1" },
        { values: [], className: "column2" } //选择器第二列
      ],
      salary: [],
      worhAddress: [
        { values: [], defaultIndex: 0, className: "worhAddress1" },
        { values: [], defaultIndex: 0, className: "worhAddress2" },
        { values: [], defaultIndex: 0, className: "worhAddress3" }
      ]
    };
  },
  computed: {
    infoList() {
      var that = this;
      let { dutyId, priceId, workId } = that;
      var info = [];
      info[0] = dutyId;
      info[1] = priceId;
      info[2] = workId;
      return info;
    }
  },
  watch: {
    infoList: {
      handler(newName, oldName) {
        var that = this;
        var infoList = that.infoList;
        if (infoList[0] !== "" && infoList[1] !== "" && infoList[2] !== "") {
          that.$emit("func", false, that.infoList);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 选择期望职位
    selectDuty(e) {
      // //(e);
      var that = this;
      that.dutyId = e[1].job_id;
      that.dutyName = e[1].name;
      that.duty = false;
    },
    changeDuty(e, values) {
      var that = this;
      // //(values);
      var id = values[0].job_id;
      if (that.id != id) {
        that.getList(id);
        that.id = id;
      }
    },
    // 获取薪资分类
    getMoneyKind() {
      var that = this;
      getKindArray({ key: "wage" }).then(res => {
        // //(res);
        if (res.code == 1) {
          that.salary = res.data;
        } else {
          Toast(res.msg);
        }
      });
    },
    //选择薪资
    selectSalary(val) {
      var that = this;
      // //(val);
      that.price = val.name;
      that.priceId = val.category_id;
      that.showPickers = false;
    },
    Onchange(e, value, index) {
      var that = this;
      var id = value[index].district_id;
      that.getAddress(id, index);
    },
    // 获取工作地点
    getAddress(id, type) {
      var that = this;
      getAreaKinds({
        parent_id: id
      }).then(res => {
        //(res);
        if (res.code == 1) {
          var list = res.data;
          switch (type) {
            case undefined:
              that.worhAddress[0].values = res.data;
              that.getAddress(res.data[0].district_id, 0);
              break;
            case 0:
              that.worhAddress[1].values = res.data;
              that.getAddress(res.data[0].district_id, 1);
              break;
            case 1:
              that.worhAddress[2].values = res.data;
              that.getAddress(res.data[0].district_id, 2);
              break;
          }
        }
      });
    },
    // 选择工作地点
    selectAddress(val) {
      //(val);
      this.workArea = `${val[0].name} - ${val[1].name} - ${val[2].name}`;
      this.workId=val[2].district_id
      this.address = false;
    },
    // 获取职位列表
    getList(id) {
      var that = this;
      var parent_id = id;
      var dutyList = that.dutyList;
      getPosition({ parent_id: parent_id }).then(res => {
        // //(res);
        if (res.code == 1) {
          if (id == undefined) {
            that.dutyList[0].values = res.data;
            that.getList(res.data[0].job_id);
          }
          that.dutyList[1].values = res.data;
        }
      });
    },
    // 获取求职意向详情
    getDetails() {
      var that = this;
      let { resumeId } = that;
      var obj = {
        resume_intent_id: resumeId
      };
      positionDetails(obj).then(res => {
        // //(res);
        if (res.code == 1) {
          that.dutyName = res.data.job_cn;
          that.price = res.data.wage_cn;
          that.workArea = res.data.district_cn;
          that.dutyId = res.data.job;
          that.priceId = res.data.wage;
          that.workId = res.data.district;
        }
      });
    }
  },
  created() {},
  mounted() {
    var that = this;
    var title = that.$route.params.title;
    if (title == 3) {
      that.getDetails(); //获取求职意向详情
    }
    that.getList(); //获取职位列表
    that.getMoneyKind();
    that.getAddress();
  }
};
</script>
<style lang='less' scoped>
.edit-boxs {
  padding: 0.2rem 0.44rem;
  font-size: 0.3rem;
  text-align: left;
  .edit-item {
    padding: 0.36rem 0;
    border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
    p {
      font-size: 0.26rem;
      font-weight: 400;
      line-height: 0.37rem;
      color: rgba(128, 128, 128, 1);
    }
    .printf-input {
      font-weight: bold;
      line-height: 0.42rem;
      color: rgba(51, 51, 51, 1);
      width: 100%;
      margin-top: 0.1rem;
      background: #fff;
    }
    .printf-input::-webkit-input-placeholder {
      font-weight: 400;
      line-height: 0.42rem;
      color: rgba(204, 204, 204, 1);
    }
  }
  .degree {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>